import { TextField, InputAdornment } from '@mui/material';
import SearchIcon from '@mui/icons-material/Search';
import PropTypes from 'prop-types';

const UserSearchInput = ({ value, onChange }) => {
	return (
		<TextField
			data-testid='user-search-input'
			placeholder='Search user or email...'
			value={value}
			onChange={onChange}
			size='small'
			InputProps={{
				startAdornment: (
					<InputAdornment position='start'>
						<SearchIcon sx={{ fontSize: 20 }} data-testid='search-icon' />
					</InputAdornment>
				),
			}}
			sx={{
				width: '250px',
			}}
		/>
	);
};

UserSearchInput.propTypes = {
	value: PropTypes.string.isRequired,
	onChange: PropTypes.func.isRequired,
};

export default UserSearchInput;
